import React from 'react'
import styled from 'styled-components'

const UserDisplayContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  border: 1px grey solid;
  min-width: 150px;
  max-width: 147px;
  max-height: 48px;
  width: 100%;
  padding: 8px 0px 8px 5px;
`

const Name = styled.div`
  font-size: 1em;
`

const StyledImg = styled.img`
  border-radius: 50%;
  height: 30px;
  width: 30px;
`

const StyledDiv = styled.div``

class UserDisplay extends React.Component {
  render() {
    return (
      <StyledDiv>
        <UserDisplayContainer onClick={this.props.toggleOpen}>
          <StyledImg src={this.props.userPicture} />
          <Name>{this.props.userName}</Name>
        </UserDisplayContainer>
      </StyledDiv>
    )
  }
}

export default UserDisplay
